import * as types from './mutations-types'

export function clearAsta(state) {
    state.commit(types.SQUADRE_CLR);
    state.commit(types.CALCIATORI_CLR);
    state.commit(types.ASTA_CLR);
}
